/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const successColor = 'success.light';

export default function CopyToClipboard({ value, buttonSx }) {
  const [clicked, setClickedState] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  return (
    <Tooltip
      open={clicked || open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => {
        setOpen(true);
      }}
      componentsProps={
        clicked
          ? {
              tooltip: { sx: { bgcolor: successColor } },
            }
          : undefined
      }
      title={clicked ? 'Copied to clipboard!' : 'Copy to clipboard'}
    >
      <IconButton
        disabled={clicked}
        sx={buttonSx}
        onClick={() => {
          setClickedState(true);
          navigator.clipboard.writeText(value);
          setTimeout(() => {
            setClickedState(false);
            setOpen(false);
          }, 1500);
        }}
      >
        {clicked ? (
          <CheckCircleOutlineIcon sx={{ color: successColor }} />
        ) : (
          <ContentCopyIcon />
        )}
      </IconButton>
    </Tooltip>
  );
}
